/* eslint-disable max-len */
/* eslint-disable react/react-in-jsx-scope */
import {
  Paper, Box, Typography, Grid, Link, Stack,
} from '@mui/material';

export const textoCadastro = (
  <Typography>
    Olá! Seja bem-vindo
    <br />
    Para que você possa usar o Portal do Titular como canal de comunicação com o nosso DPO, precisamos confirmar alguns de seus dados e conferir a autenticidade do seu cadastro.
    <br />
    Para isso, preencha os dados a seguir e, na sequência, valide o link que iremos enviar para o seu e-mail. Depois disso, assim que nossa equipe validar a autenticidade de suas informações, você poderá navegar no Portal do Titular e gerenciar suas solicitações para nossa equipe de privacidade.
    Lembre-se que, enquanto seu cadastro não fica pronto, você ainda pode falar com nosso DPO através do e-mail XXXXXXXX@XXXXXX!
  </Typography>
);
export const Documentos = (
  <Typography sx={{ color: 'white', fontSize: '13px' }} align="right">
    Precisamos agora de uma cópia do seu documento (RG ou CNH) e uma foto sua segurando o documento, onde seja possível ver seu rosto e o documento na mesma foto.
  </Typography>
);
